import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { NhatrangGuideImportResult, ServiceDto, UpdateServiceInput } from '@upme/contracts';
import { api } from '../../app/api-client';
import { serviceByIdOptions, servicesKey } from './queries';

export function useUpdateService(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdateServiceInput) =>
      api.patch(`admin/services/${id}`, { json: body }).json<ServiceDto>(),
    onSuccess: (data) => {
      qc.setQueryData(serviceByIdOptions(id).queryKey, data);
      qc.invalidateQueries({ queryKey: [...servicesKey, 'list'] });
    },
  });
}

export function useApproveService() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.post(`admin/services/${id}/approve`).json(),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'services'] }),
  });
}

export function useRejectService() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reason }: { id: string; reason: string }) =>
      api.post(`admin/services/${id}/reject`, { json: { reason } }).json(),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'services'] }),
  });
}

export function useImportNhatrangGuide() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.post('admin/services/import-nhatrang-guide').json<NhatrangGuideImportResult>(),
    onSuccess: () => qc.invalidateQueries({ queryKey: [...servicesKey, 'list'] }),
  });
}
